import { render, staticRenderFns } from "./codeList.vue?vue&type=template&id=2c95f467&scoped=true&"
import script from "./codeList.vue?vue&type=script&lang=js&"
export * from "./codeList.vue?vue&type=script&lang=js&"
import style0 from "./codeList.vue?vue&type=style&index=0&id=2c95f467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95f467",
  null
  
)

export default component.exports